
export const Profil = {
    
    cover: `https://res.cloudinary.com/df1z0o9nt/image/upload/s--hqU-nLwC--/c_fill,h_120,w_120/f_auto/q_auto/r_max/Projet_Openclassroom/Alexandre_De-Roeck.jpg`,
};
